export default __webpack_public_path__ + "static/media/city_seal_clr.fa24046c.png";